<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="sidebarMenuMini"
    hide-overlay
    stateless
    class="my-navigation"
    v-intro="'Class 1 navigation bar'"
    v-intro-position="'top'"
    v-intro-step="firstLogin ? '1' : ''"
    v-intro-highlight-class="'blue-grey darken-4 fix-hint'"
    v-intro-disable-interaction="false"
  >
    <v-list class="pt-32" dense v-if="old_new > 0">
      <template v-for="menu in menus.filter((m) => m.type === 0 && m.isShow)">
        <v-list-tile
          v-if="
            menu.name === 'Service Fee'
              ? !isFranchiseeUser
              : true && menu.routeName != 'myReferrals'
          "
          :key="menu.name"
          :to="{ name: menu.routeName }"
          @click.stop="goto(menu.routeName)"
        >
          <v-list-tile-action :class="menu.filterName">
            <div class="sidebar-icon" v-if="!sidebarMenuMini"></div>
            <v-tooltip right content-class="siderbar-tooltip" v-else>
              <template v-slot:activator="{ on }">
                <div v-on="on" class="sidebar-icon"></div>
              </template>
              <span>{{ menu.name }}</span>
            </v-tooltip>
             <span v-if="feedBackMsg&&menu.name=='Feedback'" class="spPos"></span>
          </v-list-tile-action>

          <v-list-tile-content class="pl-3">
            <v-list-tile-title>{{ menu.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
    <v-list class="pt-32" dense v-if="old_new == 0">
      <template v-for="menu in menus.filter((m) => m.type === 0 && m.isShow)">
        <v-list-tile
          v-if="
            menu.name === 'Service Fee'
              ? !isFranchiseeUser
              : true && menu.routeName != 'referrals'
          "
          :key="menu.name"
          :to="{ name: menu.routeName }"
          @click.stop="goto(menu.routeName)"
        >
          <v-list-tile-action :class="menu.filterName">
            <div class="sidebar-icon" v-if="!sidebarMenuMini"></div>
            <v-tooltip right content-class="siderbar-tooltip" v-else>
              <template v-slot:activator="{ on }">
                <div v-on="on" class="sidebar-icon"></div>
              </template>
              <span>{{ menu.name }}</span>
            </v-tooltip>
            <span v-if="feedBackMsg&&menu.name=='Feedback'" class="spPos"></span>
          </v-list-tile-action>

          <v-list-tile-content class="pl-3">
            <v-list-tile-title>{{ menu.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
    <div
      :class="sidebarMenuMini ? 'siderbar-btn-card mini' : 'siderbar-btn-card'"
    >
      <v-btn icon @click.stop="setSidebarMenuMini" class="sidebar-btn">
        <v-icon v-if="sidebarMenuMini">chevron_right</v-icon>
        <v-icon v-else>chevron_left</v-icon>
      </v-btn>
    </div>
    <course-Attendance-Dialog
      :courseAttendanceDialog="courseAttendanceDialog"
    ></course-Attendance-Dialog>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { MyReferralsOld, getTutorAbsentMsgNew } from "@/api/teachinfo";
import courseAttendanceDialog from "@/components/dialogs/courseAttendanceDialog.vue";
import {getFeedBackMsg} from '@/api/feedBack'
export default {
  name: "sidebarMenu",
  components: {
    courseAttendanceDialog,
  },
  computed: {
    ...mapGetters(["menus"]),
    // ...mapStateLayout(['feedBackMsgDialog']),
    sidebarMenuMini: function () {
      return this.$store.state.user.sidebarMenuMini;
    },
    firstLogin: function () {
      return this.$store.state.user.isFirstLogin;
    },
    isFranchiseeUser: function () {
      return this.$store.state.user.isFranchiseeUser;
    }, 
    feedBackMsg:function(){
      return this.$store.state.user.feedBackMsg;
    }
  },
  data: () => ({
    drawer: true,
    items: [
      { title: "Home", icon: "dashboard" },
      { title: "About", icon: "question_answer" },
    ],
    mini: true,
    right: null,
    old_new: 0,
    courseAttendanceDialog: {
      dialog: false,
      classTime: "",
      id: "",
      count: 0,
    },
    feedBakShow:false,
  }),
  methods: {
    goto(router) {
      if (this.sidebarMenuMini) {
        store.dispatch("setSiderBarMini", true);
      }
    },
    setSidebarMenuMini() {
      if (this.sidebarMenuMini) {
        store.dispatch("setSiderBarMini", false);
      } else {
        store.dispatch("setSiderBarMini", true);
      }
    },
  },
  created() {
    MyReferralsOld().then((res) => {
      if (res.data.ErrorCode === 0) {
        if (res.data.Msg == "RB4") {
          this.old_new = 1;
        }
      } else {
        this.$root.$alertTips(res.data.Msg);
      }
    });
    getTutorAbsentMsgNew().then((res) => {
      if (res.data.ErrorCode === 0) {
        if (res.data.Body.length != 0) {
          console.log(res.data.Body.length);
          this.courseAttendanceDialog.dialog = true;
          this.courseAttendanceDialog.classTime = res.data.Body[0].ClassTimeStr;
          this.courseAttendanceDialog.id = res.data.Body[0].Id;
          this.courseAttendanceDialog.count = res.data.Body[0].Count;
        }
      } else {
        this.$root.$alertTips(res.data.Msg);
      }
    });
    getFeedBackMsg().then(res=>{
              store.dispatch('setFeedBackMsgDialog',res.data.Body)
      })
 
    // getFeedBackMsg().then(res=>{
    //   this.feedBakShow=res.data.Body
    // })
   
  },
};
</script>
<style lang="scss">
.spPos{
  position: absolute;
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: red;
  top: 15px;
  right: 15px;
}
.my-navigation {
  width: 220px !important;
  box-shadow: 2px 0px 10px rgba(125, 162, 255, 0.19);
  position: fixed;
  margin-top: 68px !important;
  height: calc(100vh - 68px) !important;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @include bg_color($background-color-theme);
  .pt-32 {
    padding-top: 32px;
  }
  .v-navigation-drawer {
    // width: 221px;
    padding-top: 70px;
    position: fixed;
    height: 100%;
    z-index: 99;
    box-shadow: 2px 0px 10px rgba(125, 162, 255, 0.19);
    border: 0;
  }
  .v-list__tile {
    padding: 0 26px;
    font-size: 14px;
    justify-content: space-around;
    height: 60px !important;
    @include font_color($font-color-theme);

    .v-list__tile__action {
      //图标
      min-width: 20px;
    }
  }
  .primary--text {
    background: #e9f4ff;
    color: $blue-title !important;
  }
  .v-list__tile:hover {
    background: #e9f4ff !important;
  }
}
[data-layout="small"] .my-navigation .v-list__tile {
  height: 50px !important;
}
[data-layout="small"] .my-navigation .pt-32 {
  padding-top: 18px;
}
[data-layout="small"] .my-navigation {
  margin-top: 50px !important;
}
[data-theme="theme1"] .my-navigation .primary--text {
  background: #2b3043 !important;
}
[data-theme="theme1"] .my-navigation .v-list__tile:hover {
  background: #2b3043 !important;
}
.v-navigation-drawer--mini-variant .v-list__tile__content {
  display: none;
}
.v-navigation-drawer--mini-variant {
  width: 72px !important;
}
[data-layout="small"] .v-navigation-drawer--mini-variant {
  width: 54px !important;
}
.sidebar-btn {
  background: rgba(62, 103, 251, 0.2);
  border-radius: 4px;
  width: 20px;
  height: 20px;
  color: #fff !important;
  margin: 0 !important;
}
.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating)
  .v-navigation-drawer__border {
  @include bg_color($background-color-theme);
}
.siderbar-btn-card {
  height: 52px;
  text-align: right;
  padding-right: 23px;
}
.siderbar-btn-card.mini {
  text-align: center;
  padding-right: 0;
}
.sidebar-icon {
  width: 20px;
  height: 20px;
}
[data-layout="small"] .sidebar-icon {
  width: 16px;
  height: 16px;
  background-size: 100% !important;
}
.v-list [role="listitem"] .Home .sidebar-icon {
  background: url(../../assets/img/common/sidebar/dashboard.png) no-repeat;
}
.v-list [role="listitem"] .sop .sidebar-icon {
  background: url(../../assets/img/common/sidebar/sop.png) no-repeat;
}
.v-list [role="listitem"] .ClassTable .sidebar-icon {
  background: url(../../assets/img/common/sidebar/class.png) no-repeat;
}
.v-list [role="listitem"] .TrainingCenter .sidebar-icon {
  background: url(../../assets/img/common/sidebar/training.png) no-repeat;
}
.v-list [role="listitem"] .ServiceFee .sidebar-icon {
  background: url(../../assets/img/common/sidebar/fee.png) no-repeat;
}
.v-list [role="listitem"] .MyReferrals .sidebar-icon {
  background: url(../../assets/img/common/sidebar/referrals.png) no-repeat;
}
.v-list [role="listitem"] .StudentComment .sidebar-icon {
  background: url(../../assets/img/common/sidebar/comment.png) no-repeat;
}
.v-list [role="listitem"] .ComplaintList .sidebar-icon {
  background: url(../../assets/img/common/sidebar/complaint.png) no-repeat;
}
.v-list [role="listitem"] .myFeedback .sidebar-icon {
  background: url(../../assets/img/common/sidebar/feedback.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .Home .sidebar-icon {
  background: url(../../assets/img/common/sidebar/dashboard-cur.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .sop .sidebar-icon {
  background: url(../../assets/img/common/sidebar/sop-cur.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .ClassTable .sidebar-icon {
  background: url(../../assets/img/common/sidebar/class-cur.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .TrainingCenter .sidebar-icon {
  background: url(../../assets/img/common/sidebar/training-cur.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .ServiceFee .sidebar-icon {
  background: url(../../assets/img/common/sidebar/fee-cur.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .MyReferrals .sidebar-icon {
  background: url(../../assets/img/common/sidebar/referrals-cur.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .StudentComment .sidebar-icon {
  background: url(../../assets/img/common/sidebar/comment-cur.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .ComplaintList .sidebar-icon {
  background: url(../../assets/img/common/sidebar/complaint-cur.png) no-repeat;
}
.v-list [role="listitem"] .primary--text .myFeedback .sidebar-icon {
  background: url(../../assets/img/common/sidebar/feedback-cur.png) no-repeat;
}
.siderbar-tooltip {
  background: rgba(176, 179, 200, 0.9);
  box-shadow: none;
  border-radius: 4px;
  height: 28px;
  margin-top: 2px;
  &:after {
    bottom: 10px;
    left: -10px;
    border: solid transparent;
    content: " ";
    position: absolute;
    pointer-events: none;
    border-bottom-color: rgba(176, 179, 200, 0.9);
    border-color: transparent rgba(176, 179, 200, 0.9) transparent transparent;
    width: 0;
    height: 0;
    border-width: 5px;
  }
}
</style>